import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import { useCallbackPrevention } from '../../internal/hooks/usePreventedEventCallback';
import { DialogModalAction, DialogModalActions, DialogModalBody, DialogModalCancel, DialogModalCloseButton, DialogModalContent, DialogModalDescription, DialogModalFooter, DialogModalHeader, DialogModalRoot, DialogModalTitle } from './DialogModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Предсозданный компонент модального окна типа Alert
 */
export const DialogModal = /*#__PURE__*/React.memo(function DialogModal(_ref) {
  let {
    portal = true,
    size = 'M',
    width,
    open,
    onOpenChange,
    onAccept,
    onDecline,
    preventEscape,
    preventOutside,
    title,
    description,
    acceptText,
    declineText,
    hideCloseButton,
    closeButtonProps
  } = _ref;
  const preventCloseByEscape = useCallbackPrevention(preventEscape);
  const preventCloseByOutsideInteraction = useCallbackPrevention(preventOutside);
  return /*#__PURE__*/_jsx(DialogModalRoot, {
    onOpenChange: onOpenChange,
    open: open,
    modal: portal,
    children: /*#__PURE__*/_jsxs(DialogModalContent, {
      size: size,
      onInteractOutside: preventCloseByOutsideInteraction,
      onEscapeKeyDown: preventCloseByEscape,
      style: {
        width
      },
      children: [!hideCloseButton && /*#__PURE__*/_jsx(DialogModalCloseButton, _objectSpread({
        theme: "fill_dark",
        size: "XS",
        icon: /*#__PURE__*/_jsx(IconActionClose16, {
          color: "current_color"
        }),
        title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
      }, closeButtonProps)), /*#__PURE__*/_jsx(DialogModalHeader, {
        children: /*#__PURE__*/_jsx(DialogModalTitle, {
          children: title
        })
      }), /*#__PURE__*/_jsx(DialogModalBody, {
        children: /*#__PURE__*/_jsx(DialogModalDescription, {
          children: description
        })
      }), /*#__PURE__*/_jsx(DialogModalFooter, {
        children: /*#__PURE__*/_jsxs(DialogModalActions, {
          children: [/*#__PURE__*/_jsx(DialogModalCancel, {
            onClick: onDecline,
            children: declineText
          }), /*#__PURE__*/_jsx(DialogModalAction, {
            onClick: onAccept,
            children: acceptText
          })]
        })
      })]
    })
  });
});